export const SET_LOGS = 'SET_LOGS'
export const RESET_LOGS = 'RESET_LOGS'
